import React from 'react';
import PopUpDialug from './PopUpDialug';
import Review from './review';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import { GraduationCap, Globe, Microscope, BookOpen, Briefcase, BadgeDollarSign,CheckCircle, FileText  } from "lucide-react";
import { motion } from "framer-motion";
import Header from './Header';



export default function Home() {

    const d = new Date();
    let Year = d.getFullYear();

    return (
        <div className='home-container bg-gray-50'>

            <Header />
            {/* Hero Section */}
            <div className='relative w-full h-[500px] flex items-center justify-center bg-cover bg-center home-first-text' >
            <div className='absolute inset-0 bg-black opacity-50'></div>
            <div className='text-center text-white relative z-10'>
            <h1 className='text-5xl font-bold'>
            Unlock Your Future with KADSSLB Scholarships & Loans
            </h1>
            <p className='mt-4 text-lg max-w-2xl mx-auto'>
            Apply for the Kaduna State Scholarship or Loan program and take the next step 
            towards achieving your educational and career goals. Whether you need financial 
            aid through a scholarship or support with a loan, KADSSLB is here to help you succeed.
            </p>
            <div className='mt-6'>
            {/* Apply button , scholarship or loan */}
            <PopUpDialug />
            </div>
            </div>
            </div>



{/* About Governor Section */}

<motion.div
  initial={{ opacity: 0, y: 50 }}
  whileInView={{ opacity: 1, y: 0 }}
  transition={{ duration: 1.8 }}
  viewport={{ once: true }}
  className="max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-10"
>
<div className="py-20 px-6 lg:px-20 bg-gray-50">
  <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-10">
    
    {/* Image Section */}
    <div className="w-full md:w-1/2 flex justify-center">
      <img 
        src="/assets/gov-uba-sani.jpg" 
        alt="Governor of Kaduna State" 
        className="rounded-2xl  w-full max-w-5xl object-cover"
      />
    </div>

    {/* Text Section */}
    <div className="w-full md:w-1/2">
      <h2 className="text-4xl font-bold text-gray-800 mb-4">
        Meet the Executive Governor of Kaduna State
      </h2>
      <p className="text-gray-600 text-lg leading-relaxed mb-6">
        His Excellency <strong>Senator Uba Sani</strong> is the current 
        Executive Governor of Kaduna State. A visionary leader with a 
        deep commitment to education, empowerment, and social development, 
        he continues to champion initiatives that improve access to quality 
        education and provide financial support to deserving students through 
        scholarships and loans.
      </p>
      <p className="text-gray-600 text-lg leading-relaxed">
        Under his administration, Kaduna State remains a beacon of progress 
        and opportunity — fostering innovation, inclusive growth, and a 
        brighter future for all its citizens.
      </p>

      <div className="mt-6">
       {/*  <button className="bg-blue-700 text-white px-6 py-3 rounded-xl hover:bg-blue-800 transition-all">
          Learn More About His Vision
        </button> */}
      </div>
    </div>
  </div>
</div>
</motion.div>

   {/* Scholarship Information Section */}
           <div className='py-14 px-5 lg:px-20 bg-gray-100'>
  <h2 className='text-4xl font-bold text-center mb-6'>How to Apply</h2>
  <p className='text-center text-gray-600 max-w-3xl mx-auto mb-12'>
    Whether you’re applying for a <strong>Scholarship</strong> or a <strong>Loan</strong>, 
    follow the guidelines below to complete your application successfully.
  </p>

  <div className='grid md:grid-cols-2 gap-10 max-w-6xl mx-auto'>
    {/* Scholarship */}
    <div className='bg-white p-6 shadow-md rounded-lg'>
      <CheckCircle className='w-8 h-8 text-blue-600 mb-3' />
      <h3 className='text-2xl font-semibold text-blue-800'>Scholarship Eligibility</h3>
      <p className='mt-3'>
        Applicants must be Kaduna State residents with a minimum CGPA
        enrolled in an accredited institution.
      </p>
    </div>
    <div className='bg-white p-6 shadow-md rounded-lg'>
      <FileText className='w-8 h-8 text-blue-600 mb-3' />
      <h3 className='text-2xl font-semibold text-blue-800'>Scholarship Process</h3>
      <p className='mt-3'>
        Register online, submit required documents, and complete the assessment 
        test to qualify.
      </p>
    </div>

    {/* Loan */}
    <div className='bg-white p-6 shadow-md rounded-lg'>
      <CheckCircle className='w-8 h-8 text-green-600 mb-3' />
      <h3 className='text-2xl font-semibold text-green-800'>Loan Eligibility</h3>
      <p className='mt-3 '>
        Applicants must be Kaduna State citizen (indigene / resident) , enrolled in an accredited 
        institution or recognized program, and provide sponsors/guarantor details for verification.
      </p>
    </div>
    <div className='bg-white p-6 shadow-md rounded-lg'>
      <FileText className='w-8 h-8 text-green-600 mb-3' />
      <h3 className='text-2xl font-semibold text-green-800'>Loan Process</h3>
      <p className='mt-3'>
        Register online, submit required documents, specify loan amount and purpose, provide sponsors/guarantors details
        and complete the application process.
      </p>
    </div>
  </div>
</div>




            {/* Featured Scholarships Slider */}
            <div className='w-full py-10 px-5 lg:px-20 bg-white'>
                <h2 className='text-4xl font-bold text-center mb-6 capitalize font-mono'>Featured Scholarships And  Student Tertiary Education Loans</h2>
                <Swiper
                    modules={[Navigation, Pagination, Autoplay]}
                    spaceBetween={30}
                    slidesPerView={1}
                    navigation
                    pagination={{ clickable: true }}
                    autoplay={{ delay: 3000 }}
                    breakpoints={{
                        640: { slidesPerView: 1 },
                        768: { slidesPerView: 2 },
                        1024: { slidesPerView: 3 },
                    }}
                    className='max-w-6xl mx-auto'
                > 


                  {/* Scholarship Slides */}
                    <SwiperSlide className='p-4 bg-blue-100 rounded-lg text-center'>
                    <GraduationCap className='mx-auto w-10 h-10 text-blue-700 mb-2' />
                    <h3 className='text-xl font-semibold'>Need-Based Scholarship</h3>
                    <p className='mt-2'>Beneficiary must have a minimum of Grade C in at least five (5) Subjects  Including Maths and English. And must Maintain a minimum CGPA of 2.5</p>
                    </SwiperSlide>

                    <SwiperSlide className='p-4 bg-green-100 rounded-lg text-center'>
                    <BookOpen className='mx-auto w-10 h-10 text-green-700 mb-2' />
                    <h3 className='text-xl font-semibold'>Merit-Based  Scholarship</h3>
                    <p className='mt-2'>Scholarship. The beneficiary must have a minimum of Grade B in at least five (5) Subjects  and Grade C in other subjects. And must Maintain a minimum CGPA of 4.0</p>
                    </SwiperSlide>

                    <SwiperSlide className='p-4 bg-yellow-100 rounded-lg text-center'>
                    <Globe className='mx-auto w-10 h-10 text-yellow-700 mb-2' />
                    <h3 className='text-xl font-semibold'>PLWD Scholarship</h3>
                    <p className='mt-2'>Beneficiary must have a minimum of Grade C in at least five (5) Subjects  Including Maths and English. And must Maintain a minimum CGPA of 2.5</p>
                    </SwiperSlide>


                    <SwiperSlide className='p-4 bg-red-100 rounded-lg text-center'>
                    <Microscope className='mx-auto w-10 h-10 text-red-700 mb-2' />
                    <h3 className='text-xl font-semibold'>Sport-Based Scholarship</h3>
                    <p className='mt-2'>Beneficiary must have a minimum of Grade C in at least five (5) Subjects  Including Maths and English. And must Maintain a minimum CGPA of 2.5</p>
                    </SwiperSlide>


                    {/* Loan Slides */}
                    <SwiperSlide className='p-4 bg-purple-100 rounded-lg text-center'>
                    <BadgeDollarSign className='mx-auto w-10 h-10 text-purple-700 mb-2' />
                    <h3 className='text-xl font-semibold'>Student Tertiary Education Loans</h3>
                    <p className='mt-2'>Students can access loans directly.</p>
                    </SwiperSlide>

                    <SwiperSlide className='p-4 bg-orange-100 rounded-lg text-center'>
                    <BadgeDollarSign className='mx-auto w-10 h-10 text-orange-700 mb-2' />
                    <h3 className='text-xl font-semibold'>Student Tertiary Education Loans(Third-Party Guarantee)</h3>
                    <p className='mt-2'>Students can access loans through sponsor(s).</p>
                    </SwiperSlide>

              
                </Swiper>
            </div>

         
            {/* Testimonials Section */}
            <div className='py-14 bg-white flex justify-center items-center flex-col'>
                <h2 className='text-4xl font-bold text-center mb-6'>What Our Scholars Say</h2>
                <Review />
            </div>

            {/* Footer */}
            <footer className='text-center py-6 bg-gray-800 text-white font-mono'>
                <h4 className='font-bold'>All rights reserved Kaduna State Government &copy; {Year}</h4>
                <h5 className='font-mono'><a target='_blank' rel='noopener noreferrer' href='https://mmt-ng.com' className='underline'>Powered By MastermindTech</a></h5>
            </footer>
        </div>
    );
}
 